import { useSetting } from '@tencent/setting-vue-webpack-plugin';
export default useSetting('榜单配置', {
  福利1: {
    type: 'object',
    properties: {
      公告: '宠爱榜TOP3粉丝可展示应援灯牌',
      规则按钮: '规则',
      规则内容: {
        type: 'richText',
        default: ''
      }
    }
  },
  福利2: {
    type: 'object',
    properties: {
      公告: '宠爱榜TOP5粉丝可获取限定周边',
      规则按钮: '规则',
      规则内容: {
        type: 'richText',
        default: ''
      },
      查看中奖按钮: '查看名单',
      中奖名单弹窗标题: '恭喜以下5位获得火箭少女101官方周边',
      中奖人数: 5
    }
  },
  底部说明: '购买10份+即可获得火少铁粉专属标',
  灯牌默认文案: '遇见火箭少女101，告别不说再见',
  灯牌编辑说明: '榜单前3名粉丝的灯牌全网用户可见哦，您可定制文案给少女们打call，定制文案人工请等待审核通过，审核时间预计1小时~'
});